module.exports = __webpack_public_path__ + "fonts/Muli-Black.887852a7.ttf";